<div class="document-container" [@slideUp]>
  <div *ngIf="document_list.length > 0; else noDocuments" class="add-doc-btn">
    <button *ngIf="toggleAddDoc" (click)="openAddDocumentModel()">Add Document</button>
  </div>

  <ng-template #noDocuments>
    <img class="no-goal-img" src="assets\images\no-goal.png" alt="" />
    <div class="add-middoc-btn">
      <button *ngIf="toggleAddDoc" (click)="openAddDocumentModel()">Add Document</button>
    </div>
  </ng-template>

  <div class="row document-row">
    <div class="col-12 col-md-6 mb-3" style="padding-right:0;" *ngFor="let doc of document_list">
      <app-doc-card (updateDocumentList)="getUserDocuments()" [docType]="DocumentEnum.VOTER_ID"
        [documentDetails]="doc"></app-doc-card>
    </div>
  </div>
</div>
